// Module
var code = "<div class=\"c-alert-message\" :class=\"type\"> <div class=\"alert-slot flex-center\" style=\"max-width:600px\"> <icon :name=\"alertIcon\"></icon> <slot></slot> </div> </div> ";
// Exports
export default code;